module.exports = __webpack_public_path__ + "static/media/creditcard.d8d7c0e5.jpg";